const NAV_SELECTOR = "[data-scrollspy]";

function onIntersection(entries) {
  const link = this;
  const closest = link.closest(NAV_SELECTOR);
  const { left } = link.getBoundingClientRect();
  const linkParent = link.parentNode;

  entries.forEach(({ isIntersecting }) => {
    if (isIntersecting) {
      linkParent.classList.add("active");
      if (closest) {
        closest.scrollLeft += left;
      }
    } else {
      linkParent.classList.remove("active");
    }
  });
}

function observeTarget(link) {
  const target = document.querySelector(link.getAttribute("href"));

  if (!target) {
    return;
  }

  const stickyNavObserver = new IntersectionObserver(
    onIntersection.bind(link),
    {
      root: null,
      rootMargin: "-10% 0px -90% 0px",
      threshold: 0
    }
  );

  stickyNavObserver.observe(target);
}

function scrollSpy(container = document.querySelector(NAV_SELECTOR)) {
  if (!container) {
    return;
  }

  container.querySelectorAll("a").forEach(observeTarget);
}

export default scrollSpy;



// WEBPACK FOOTER //
// ./components/scrollspy/scrollspy.js